import { string, object, number } from 'prop-types';

const validationTypes = {
  // HTML wrapped text (CKEditor inputs)
  // No max length because may include link urls
  optionalHtmlText: { type: string },
  requiredHtmlText: { minLength: 1, removeHtml: true, type: string },
  // Basic text input
  optionalText: { type: string },
  requiredText: { minLength: 1, type: string },
  optionalTitle: { maxLength: 30, type: string },
  requiredTitle: { minLength: 1, maxLength: 30, type: string },
  // Button texts
  optionalButton: { maxLength: 30, type: string },
  requiredButton: { minLength: 1, maxLength: 30, type: string },
  // Link inputs
  optionalLink: { status: 'published', type: object },
  requiredLink: { hasLink: true, status: 'published', type: object },
  // HREF / External link inputs
  optionalHref: { isUrl: true, type: string },
  requiredHref: { minLength: 1, isUrl: true, type: string },
  // Video URL
  optionalVideoUrl: { isUrl: true, isVideoUrl: true, type: string },
  requiredVideoUrl: { minLength: 1, isUrl: true, isVideoUrl: true, type: string },
  // Integer inputs
  optionalNumber: { type: number },
  requiredNumber: { hasInteger: true, type: number },
};

export default {
  optionalSectionHeading: validationTypes.optionalHtmlText,
  requiredSectionHeading: validationTypes.requiredHtmlText,
  basicBlock: {
    heading: validationTypes.optionalText,
    content: validationTypes.optionalText,
    page: validationTypes.requiredLink
  },
  quoteBlock: {
    heading: validationTypes.optionalHtmlText,
    name: validationTypes.requiredTitle,
    quote: validationTypes.requiredText
  },
  promoBlock: {
    heading: validationTypes.optionalHtmlText,
    button: validationTypes.requiredButton,
    content: validationTypes.requiredHtmlText,
    page: validationTypes.requiredLink
  },
  magazineSection: {
    button: validationTypes.requiredButton,
    content: validationTypes.requiredHtmlText,
    page: validationTypes.requiredLink
  },
  videoSection: {
    videoUrl: validationTypes.requiredVideoUrl,
    content: validationTypes.optionalHtmlText,
    date: validationTypes.optionalText,
    label: validationTypes.optionalText,
  },
  columnBlock: {
    heading: validationTypes.optionalHtmlText,
    page: validationTypes.requiredLink,
    content: validationTypes.optionalHtmlText
  },
  iconBlock: {
    heading: validationTypes.optionalHtmlText,
    content: validationTypes.optionalHtmlText,
    button: validationTypes.requiredButton,
    // Icon block page links are EITHER page or external link
    page: { ...validationTypes.requiredLink, orInput: 'externalLink' },
    externalLink: { ...validationTypes.requiredHref, orInput: 'page' },
  },
  benefitCtaBlock: {
    label: validationTypes.requiredText,
  }
};
